export default __webpack_public_path__ + "static/media/processcard.a3677999.png";